
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[categoryOrPage]/[slug]",
      function () {
        return require("private-next-pages/[categoryOrPage]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[categoryOrPage]/[slug]"])
      });
    }
  